var React = require('react');

function Garage (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128,512H512V352H128.11Zm144-96h96a16,16,0,0,1,0,32H272a16,16,0,0,1,0-32Zm240-192L128,224v96H511.52Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M640,161.28V496a16,16,0,0,1-16,16H560a16,16,0,0,1-16-16V224c0-17.59-14.59-32-32.59-32H128.59c-18,0-32.59,14.41-32.59,32V496a16,16,0,0,1-16,16H16A16,16,0,0,1,0,496V161.28A48.14,48.14,0,0,1,29.5,117l272-113.3A57.4,57.4,0,0,1,320,0a57.4,57.4,0,0,1,18.46,3.67L610.5,117A48.14,48.14,0,0,1,640,161.28Z","className":"fa-primary","key":2})]);
}

Garage.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Garage;

Garage.default = Garage;
